import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

import Layout from 'components/common/Layout';
import SignUp from 'components/account/SignUp';
import AccountNavigation from 'components/account/AccountNavigation';
import AccountLogo from 'components/account/AccountLogo';

import { appTitle, titleSeparator } from 'config/helmetSettings';
import tidioSrc from 'config/tidioSrc';

class AccountSignUp extends Component {
  componentDidMount() {
    const htmlEl = document.querySelector('html');
    htmlEl.classList.add('page-with-tidio');
  }

  componentWillUnmount() {
    const htmlEl = document.querySelector('html');
    htmlEl.classList.remove('page-with-tidio');
  }

  render() {
    const { history } = this.props;
    return (
      <Layout variant="account-login">
        <Helmet>
          <title>
            {appTitle} {titleSeparator} Sign Up
          </title>
          <script src={tidioSrc} async />
        </Helmet>
        <AccountLogo />
        <SignUp
          form="signUpForm"
          onSubmitSuccess={() => {
            // history.replace('/');
          }}
        />
        <AccountNavigation />
      </Layout>
    );
  }
}

AccountSignUp.propTypes = {
  history: PropTypes.shape({
    replace: PropTypes.func.isRequired,
  }).isRequired,
};

export default AccountSignUp;



// WEBPACK FOOTER //
// ./src/pages/account/AccountSignUp.js